import React from 'react';
import './NewsMarquee.css';

const staticContent = (
  <>
    Welcome Soldiers of Cinema to{' '}
    <a href="https://2jakes.tv/">2Jakes.tv</a> and{' '}
    <a href="https://neutralsfilm.com/">neutralsfilm.com</a>! Your central hub for the latest updates on the punk rock comedy film{' '}
    <em>Neutrals</em> and future creative projects from The Two Jakes Film Productions (est. 2022).{' '}
    <strong>CLICK HERE</strong> for more news and to see where you can find <em>Neutrals</em> next!
  </>
);

const NewsMarquee = React.memo(function NewsMarquee({ onClick }) {
  return (
    <div className="news-marquee" onClick={onClick}>
      <div className="marquee-content">{staticContent}</div>
    </div>
  );
});

export default NewsMarquee;
